import { useEffect, useRef } from "react";
import { useSidebar } from "@/components/ui/sidebar";

export function useCollapsedSidebar(isActive: boolean) {
  const { open, setOpen, isMobile } = useSidebar();
  const sidebar = useRef({ open, setOpen, isMobile });
  sidebar.current = { open, setOpen, isMobile };

  useEffect(() => {
    if (!isActive || sidebar.current.isMobile) {
      return;
    }
    const wasOpen = sidebar.current.open;
    sidebar.current.setOpen(false);
    return () => {
      if (wasOpen) {
        sidebar.current.setOpen(true);
      }
    };
  }, [isActive]);
}
